import type { UserCompanyNotificationDto } from '@/services/ws-comments/src/main/resources/rest-api';
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';

import { ROUTER } from 'src/AppRouter.tsx';
import type { OpenNotificationState } from './types.ts';

export const useOpenNotification = () => {
  return useCallbackRef((notification: UserCompanyNotificationDto | null | undefined) => {
    const state: OpenNotificationState | undefined = notification ? { notification } : undefined;
    ROUTER['/notifications/system'].path.navigate({}, { state });
  });
};
